import React from "react";

const OnlineModal = () => {
  return <div>Online Modal</div>;
};

export default OnlineModal;
